import axios from "axios";
import { readSharedAuthSnapshot } from "../utils/sharedAuth";
import { API_CORE } from "../utils/constants";

const API_BASE_URL = (
  process.env.REACT_APP_API_CORE_URL ||
  process.env.VITE_API_CORE_URL ||
  `${API_CORE}/`
).replace(/\/+$/, "") + "/";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: false,
});

// ➕ Intercepteur pour ajouter le token JWT
apiClient.interceptors.request.use((config) => {
  const token = readSharedAuthSnapshot().access;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default apiClient;
